<template>
  <div class="md:pt-64 lg:pt-64 pt-96 pb-12 relative z-index1">
    <div class="absolute bg-faq-dots z-index--1 mob-hidden">
      <img
        src="../../../assets/images/caregiver/faq-dots.svg"
        alt="bg-polygon"
        class="w-full"
      />
    </div>
    <div class="absolute bg-faq-poly1 z-index--1 mob-hidden">
      <img
        src="../../../assets/images/caregiver/faq-poly1.svg"
        alt="bg-polygon"
        class="w-full"
      />
    </div>
    <div class="absolute bg-faq-poly2 z-index--1 mob-hidden">
      <img
        src="../../../assets/images/caregiver/faq-poly2.svg"
        alt="bg-polygon"
        class="w-full"
      />
    </div>
    <div class="w-full mx-auto lg:px-12 md:px-12 px-4">
      <p
        class="title w-full sm-fsize16 md:font-normal lg:font-normal font-bold"
      >
        FAQ's
      </p>
      <div
        class="md:mt-10 lg:mt-10 mt-4 md:py-6 lg:py-6 py-4 md:px-8 lg:px-8 px-4 cust-shadow-FAQ rounded-lg bg-white z-10"
        v-for="(item, index) in faq"
        :key="index"
      >
        <div
          class="flex items-center w-full justify-between cursor-pointer"
          block
          v-b-toggle="'accordion-' + index"
        >
          <p class="subtitle txt-FAQ-A fsize20-14px">
            {{ item.que }}
          </p>
          <img
            src="../../../assets/images/caregiver/downIcon.svg"
            alt="Downicon"
            class="md:h-4 lg:h-4 h-2 w-6"
          />
        </div>
        <b-collapse
          :id="'accordion-' + index"
          accordion="my-accordion"
          role="tabpanel"
        >
          <p class="subtitle pt-8 fsize20-14px">
            {{ item.answer }}
          </p>
        </b-collapse>
      </div>
      <!-- <div
        class="
          md:mt-10
          lg:mt-10
          mt-4
          md:py-6
          lg:py-6
          py-4
          md:px-8
          lg:px-8
          px-4
          cust-shadow-FAQ
          rounded-lg
          bg-white
          z-10
        "
        v-for="(item, index) in faq"
        :key="index"
      >
        <div
          class="flex items-center w-full justify-between cursor-pointer"
          block
          v-b-toggle.accordion-4
        >
          <p class="subtitle txt-FAQ-A fsize20-14px">
            {{ item.que }}
          </p>
          <img
            src="../../../assets/images/caregiver/downIcon.svg"
            alt="Downicon"
            class="md:h-4 lg:h-4 h-2 w-6"
          />
        </div>
        <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
          <p class="subtitle pt-8 fsize20-14px">
            {{ item.answer }}
          </p>
        </b-collapse>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      faq: [
        {
          id: "01",
          que: "What is the benefit of joining your learning programmes?",
          answer:
            "We believe your role is critical for the well-being of a patient and their family. Our learning programmes guide you on how to build an effective communication channel with a patient's family and build their confidence in you and your advisory in retrospect. What is the benefit of joining your learning programmes?	We believe your role is critical for the well-being of a patient and their family. Our learning programmes guide you on how to build an effective communication channel with a patient's family and build their confidence in you and your advisory in retrospect. We also acknowledge the stress that you may face when dealing with such cases every day. Our programmes also guide you on how to focus on your well-being to enhance your productivity levels.",
        },
        {
          id: "02",
          que: "I run a professional caregiver agency. How can I collaborate with Caregiver Saathi?",
          answer:
            "We offer partnerships whereby our caregiver community can avail your services through our platform. For further discussions, please fill in the partnership enquiry form and we will get back to you.",
        },
      ],
    };
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
